/**
 * حل ارجاع‌های پاسخ به شاهد تکمیلی متناظر.
 *
 * ⚠️ **چرا مشترک شد:** نسخه‌ی مشتری ارجاع‌ها را اصلاً نشان نمی‌داد و تنها نمای
 * آزمایشگاه استودیو آن‌ها را رندر می‌کرد. یعنی همان مخاطبی که باید به پاسخ اعتماد
 * کند، پشتوانه‌ی ادعاها را نمی‌دید. با یک تابع مشترک، هر دو نما یک تعریف از
 * «ارجاع قابل بررسی» دارند و واگرایی دوباره ممکن نیست.
 */

import type { SourceCitation, SupplementaryEvidence, SupplementaryKind } from '@/lib/types'

/** ارجاع، پس از اتصال به شاهدی که واقعاً بازیابی شده است. */
export interface ResolvedCitation {
  itemId: string
  /** ادعایی که این ارجاع پشتوانه‌ی آن است. */
  usedFor: string
  /** متن استناد خوانا، مثل «سند بودجه ۱۴۰۳ — صفحه ۳». */
  text: string
  /** عنوان شاهد. خالی یعنی شاهد در فهرست بازیابی‌شده نبود. */
  title: string
  kind: SupplementaryKind | null
}

/**
 * ارجاع‌ها را به شواهد بازیابی‌شده وصل می‌کند.
 *
 * شاهد پیدانشده حذف نمی‌شود بلکه با شناسه نمایش داده می‌شود: شناسه هم قابل
 * پیگیری است و حذف کامل ارجاع، ادعا را بی‌پشتوانه نشان می‌داد.
 */
export const resolveCitations = (
  citations: SourceCitation[],
  supplementary: SupplementaryEvidence[],
): ResolvedCitation[] =>
  citations.map((citation) => {
    const found = supplementary.find((entry) => entry.item.item_id === citation.item_id)
    return {
      itemId: citation.item_id,
      usedFor: citation.used_for,
      text: found === undefined ? citation.item_id : found.item.citation,
      title: found === undefined ? '' : found.item.title,
      kind: found === undefined ? null : found.item.kind,
    }
  })

/** برچسب فارسی نوع شاهد تکمیلی. */
export const CITATION_KIND_LABELS: Record<SupplementaryKind, string> = {
  principle: 'اصل تصمیم',
  section: 'بخش سند',
}
